import { useDispatch, useSelector } from "react-redux";
import {
  calculateDebtLoadRequest,
  resetDebtLoadCalculate,
} from "../../../redux/actions/debtLoadAction";
import { useCallback, useEffect } from "react";

export const useDebtLoadCalculation = (
  clientId,
  calculationResult,
  previousDealId,
) => {
  const dispatch = useDispatch();
  const {
    debtLoadCalculation,
    debtCalculateError,
    debtLoadCalculationLoading
  } = useSelector(({ debtLoad }) => debtLoad);

    const shouldCalculateDebtLoad = (amount) => {
      if (calculationResult.calculateDebtLoad && debtLoadCalculation?.debtOverloadRate) {
        calculateDebtLoad(amount);
      } else {
        dispatch(resetDebtLoadCalculate())
      }
    }
    
    const calculateDebtLoad = useCallback((amount) => {
      dispatch(calculateDebtLoadRequest(clientId, amount, previousDealId, calculationResult.currentDealDuration));
    }, [clientId, previousDealId, dispatch, calculationResult.currentDealDuration]);

    useEffect(() => {
        if(clientId) {
            shouldCalculateDebtLoad(calculationResult?.amount)
        }
    }, [calculationResult?.amount, clientId, calculationResult.currentDealDuration])

  return {
    debtLoadCalculation,
    debtCalculateError,
    debtLoadCalculationLoading,
    calculateDebtLoad,
    shouldCalculateDebtLoad,
  };
};
